var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 96.03 96.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m47.65,0C21.33,0,0,21.33,0,47.65v48.38s48.38,0,48.38,0c26.31,0,47.65-21.33,47.65-47.65V0s-48.38,0-48.38,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--iconBgColor)",
    d: "m15.1,48.01c0-18.15,14.77-32.92,32.92-32.92s32.92,14.77,32.92,32.92-14.77,32.92-32.92,32.92S15.1,66.16,15.1,48.01Zm53.03,0c0-11.09-9.02-20.11-20.11-20.11s-20.11,9.02-20.11,20.11,9.02,20.11,20.11,20.11,20.11-9.02,20.11-20.11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.943d1a2f957168858f980b10df20b204.svg";
export { ForwardRef as ReactComponent };